import { useState, useCallback, useEffect } from "react";
import axios from "axios";
import { useParams } from "react-router-dom";
import CircularProgress from "@mui/material/CircularProgress";
import Backdrop from "@mui/material/Backdrop";
import Sidebar from "../../../Sidebar/Sidebar";
import { url } from "../../../App";
import Cookies from "js-cookie";
import { ToastContainer, toast } from "react-toastify";
import ViewBorrowerDoc from "../BorrowerDetails/Components/SectionThree/ViewBorrowerDoc";
import { useBorrowerContext } from "../BorrowerDetails/store/borrower-details";
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import { useNavigate } from "react-router-dom";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";

const ALL_DOC_TYPES = [
  "Self Photo",
  "PAN Card",
  "Aadhar",
  "Current Address Proof",
  "Election Card",
  "Driving License",
  "Ration Card",
  "Passport",
  "Self Attested KYC",
  "RC",
];

const fieldsArr = [
  { field: "borrower_selfphoto", setState: "selfie" },
  { field: "borrower_pancard", setState: "pan" },
  { field: "borrower_aadhar_front", setState: "aadharFront" },
  { field: "borrower_aadhar_back", setState: "aadharBack" },
  { field: "borrower_current_address_proof", setState: "currentAddressProof" },
  { field: "borrower_driving_license", setState: "drivingLicense" },
  { field: "borrower_ration_card", setState: "rationCard" },
  { field: "borrower_election_card", setState: "voterID" },
  { field: "borrower_passport", setState: "passport" },
  { field: "borrower_self_attested_kyc", setState: "selfAttested" },
  { field: "borrower_rc", setState: "rc" },
];

const DOC_NAME_TO_API = {
  "Self Photo": "self_photo",
  "PAN Card": "pan_card",
  "Aadhar Card Front": "aadhar_front",
  "Aadhar Card Back": "aadhar_back",
  "Current Address Proof": "current_address_proof",
  "Driving License": "borrower_driving_license",
  "Ration Card": "borrower_ration_card",
  "Election Card": "borrower_election_card",
  "Passport": "borrower_passport",
  "Self Attested KYC": "borrower_self_attested_kyc",
  "RC": "borrower_rc",
};

const DOC_ALLOWED_FORMATS = {
  "Self Photo": ["jpg", "jpeg", "png"],
  "PAN Card": ["jpg", "jpeg", "png"],
  "Aadhar Card Front": ["jpg", "jpeg", "png"],
  "Aadhar Card Back": ["jpg", "jpeg", "png"],
  "Current Address Proof": ["jpg", "jpeg", "png", "pdf"],
  "Election Card": ["jpg", "jpeg", "png"],
  "Driving License": ["jpg", "jpeg", "png"],
  "Ration Card": ["jpg", "jpeg", "png"],
  "Passport": ["jpg", "jpeg", "png"],
  "Self Attested KYC": ["jpg", "jpeg", "png"],
  "RC": ["jpg", "jpeg", "png"],
};

export default function UploadKYCDocs() {
  const navigate = useNavigate();
  const { updateBorrowerData, borrowerData } = useBorrowerContext();
  const borrowerDetails = borrowerData?.borrower;
  const { id } = useParams();
  const uniqueNumber = id;
  const [open, setOpen] = useState(false);
  const [isOpen, setIsOpen] = useState(true);
  const openView = (val) => setIsOpen(val);
  const token = Cookies.get("Token");
  const email = Cookies.get("Email");
  const [selectedType, setSelectedType] = useState("");
  const [uploadItems, setUploadItems] = useState([]);
  const [aadharFront, setAadharFront] = useState(null);
  const [aadharBack, setAadharBack] = useState(null);
  const [aadharFrontType, setAadharFrontType] = useState("");
  const [aadharBackType, setAadharBackType] = useState("");
  const [aadharFrontBase64, setAadharFrontBase64] = useState("");
  const [aadharBackBase64, setAadharBackBase64] = useState("");
  const [borrowerDocModal, setBorrowerDocModal] = useState(false);
  const [docName, setDocName] = useState("");
  const [title, setTitle] = useState("");
  const [modalType, setModalType] = useState("");
  const [activeDoc, setActiveDoc] = useState(null);
  const [AddDocVisible, setAddDocVisible] = useState(false);
  const [ViewDocVisible, setViewDocVisible] = useState(false);
  const [DownloadDocVisible, setDownloadDocVisible] = useState(false);
  const [visible, setvisible] = useState(false);

  const [docExist, setDocExist] = useState({
    selfie: false,
    pan: false,
    aadharFront: false,
    aadharBack: false,
    currentAddressProof: false,
    drivingLicense: false,
    rationCard: false,
    voterID: false,
    passport: false,
    selfAttested: false,
    rc: false,
  });

  useEffect(() => {
    if (email === "rupesh.bishnoi@credin.in") {
      setvisible(true);
    } else {
      axios
        .post(url + "/user/getsingle", {
          token: token,
          email: email,
          useremail: email
        })
        .then((res) => {
          setAddDocVisible(res.data[0].permission.add_borrower_document);
          setViewDocVisible(res.data[0].permission.view_borrower_document);
          setDownloadDocVisible(res.data[0].permission.download_borrower_document)
        })
        .catch((err) => {
          console.log(err);
          toast.error(err.message);
        })
    };
  }, [token, email]);

  useEffect(() => {
    const checkDocsExistance = () => {
      fieldsArr.forEach(({ field, setState }) => {
        const fieldValue = borrowerDetails?.[field] || borrowerDetails[0]?.[field];
        if (
          fieldValue &&
          (Array.isArray(fieldValue)
            ? fieldValue.length !== 0
            : Object.keys(fieldValue).length !== 0)
        ) {
          setDocExist((prev) => {
            const newState = { ...prev, [setState]: true };
            return newState;
          });
        }
      });
    };

    if (borrowerDetails) checkDocsExistance();
  }, [borrowerDetails]);

  useEffect(() => {
    ALL_DOC_TYPES.forEach((type) => {
      const exists =
        (type === "Self Photo" && docExist.selfie) ||
        (type === "PAN Card" && docExist.pan) ||
        (type === "Aadhar" && (docExist.aadharFront || docExist.aadharBack)) ||
        (type === "Current Address Proof" && docExist.currentAddressProof) ||
        (type === "Driving License" && docExist.drivingLicense) ||
        (type === "Ration Card" && docExist.rationCard) ||
        (type === "Election Card" && docExist.voterID) ||
        (type === "Passport" && docExist.passport) ||
        (type === "Self Attested KYC" && docExist.selfAttested) ||
        (type === "RC" && docExist.rc);

      if (exists) {
        setUploadItems((prev) => {
          const alreadyAdded = prev.some((item) => item.type === type);
          if (!alreadyAdded) {
            return [...prev, { type, files: [], success: true }];
          }
          return prev;
        });
      }
    });
  }, [docExist]);

  const handleAddDocType = () => {
    if (!selectedType) return;
    if (selectedType === "Aadhar") {
      if (!uploadItems.some((item) => item.type === "Aadhar")) {
        setUploadItems((prev) => [
          ...prev,
          { type: "Aadhar", files: [], success: false },
        ]);
      }
      setSelectedType("");
      return;
    }

    if (!uploadItems.some((item) => item.type === selectedType)) {
      setUploadItems((prev) => [...prev, { type: selectedType, files: [], success: false }]);
    }
    setSelectedType("");
  };

  async function uploadKycDocument(apiDocName, file) {
    setOpen(true);
    try {
      if (!file) {
        toast.error("No file selected");
        throw new Error("No file");
      }

      let extension = file.name.split(".").pop().toLowerCase();

      if (!["jpg", "jpeg", "png"].includes(extension)) {
        toast.error("Please upload JPG or PNG only");
        throw new Error("Invalid file format");
      }

      if (extension === "jpg") extension = "jpeg";

      const base64_data = await new Promise((resolve, reject) => {
        const reader = new FileReader();

        reader.onload = (e) => {
          const data = e.target.result.replace(
            `data:image/${extension};base64,`,
            ""
          );
          resolve(data);
        };

        reader.onerror = () => {
          reject(new Error("FileReader failed"));
        };

        reader.readAsDataURL(file);
      });

      const res = await axios.post(url + "/borrower/adddocument", {
        borrower_uniqueno: uniqueNumber,
        doc_name: apiDocName,
        doc_type: extension,
        token,
        email,
        fileName: base64_data,
      });

      if (!res?.data?.auth) {
        throw new Error(res?.data?.message || "Upload failed");
      }

      toast.success(res?.data?.message || "Uploaded successfully");

      const borrowerRes = await axios.post(
        url + "/borrower/borrowertoalldetails",
        {
          token,
          email,
          borrower_uniqueno: uniqueNumber,
        }
      );

      if (!borrowerRes?.data?.auth) {
        throw new Error("Failed to refresh borrower data");
      }

      updateBorrowerData((prev) => ({
        ...prev,
        borrower: borrowerRes?.data?.message?.borrower,
      }));

      return true;
    } catch (err) {
      console.error("Upload error:", err);
      if (!err.silent) toast.error(err.message || "Something went wrong");
      return false;
    } finally {
      setOpen(false);
    }
  }

  const uploadPanWithOCR = async (file) => {
    setOpen(true);
    let extension = file.name.split(".").pop().toLowerCase();
    if (!["jpg", "jpeg", "png"].includes(extension)) {
      setOpen(false);
      toast.error("Please upload PAN in JPG or PNG format only");
      return;
    }
    if (extension === "jpg") extension = "jpeg";

    const reader = new FileReader();
    reader.readAsDataURL(file);

    reader.onload = async (e) => {
      const base64_data = e.target.result.replace(
        `data:image/${extension};base64,`,
        ""
      );

      try {
        const res = await axios.post(url + "/borrower/adddocument", {
          borrower_uniqueno: uniqueNumber,
          doc_name: "pan_card",
          doc_type: extension,
          token,
          email,
          fileName: base64_data,
        });

        if (res.data.auth === true) {
          toast.success(res.data.message);
        } else {
          toast.error(res.data.message);
          handlePanUpdate(base64_data, extension);
        }

        const updateBorrower = await axios.post(
          url + "/borrower/borrowertoalldetails",
          {
            token,
            email,
            borrower_uniqueno: uniqueNumber,
          }
        );

        if (!updateBorrower?.data?.auth) {
          setOpen(false);
          return;
        }

        updateBorrowerData((prev) => ({
          ...prev,
          borrower: updateBorrower?.data?.message?.borrower,
        }));
        setOpen(false);
      } catch (err) {
        setOpen(false);
        toast.error(err.message || "Something went wrong");
      }
    };
  };

  const handlePanUpdate = (base64_data, extension) => {
    setTimeout(() => {
      if (window.confirm("Do you want to update PAN Details?")) {
        setOpen(true);

        axios.post(url + "/borrower/mismatchpan", {
          borrower_uniqueno: uniqueNumber,
          doc_name: "pan_card",
          doc_type: extension,
          token,
          email,
          fileName: base64_data,
        })
          .then((res) => {
            if (res.data.auth === true) {
              toast.success(res.data.message);
            } else {
              toast.error(res.data.message);
            }
          })
          .catch((err) => {
            toast.error(err.message);
          })
          .finally(() => {
            setOpen(false);
          });
      } else {
        toast.error("PAN Details NOT updated");
      }
    }, 3000);
  };

  const uploadAadharFront = (file) => {
    if (!file) return;

    let type = file.name.split(".").pop().toLowerCase();
    if (!["jpg", "png", "jpeg"].includes(type)) {
      toast.error("Upload Aadhaar Front in JPG/PNG only");
      return;
    }
    if (type === "jpg") type = "jpeg";

    setAadharFront(file);
    setAadharFrontType(type);
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = (e) => {
      const base64 = e.target.result.replace(`data:image/${type};base64,`, "");
      setAadharFrontBase64(base64);
    };
  };

  const uploadAadharBack = (file) => {
    if (!file) return;

    let type = file.name.split(".").pop().toLowerCase();
    if (!["jpg", "png", "jpeg"].includes(type)) {
      toast.error("Upload Aadhaar Back in JPG/PNG only");
      return;
    }
    if (type === "jpg") type = "jpeg";

    setAadharBack(file);
    setAadharBackType(type);
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = (e) => {
      const base64 = e.target.result.replace(`data:image/${type};base64,`, "");
      setAadharBackBase64(base64);
    };
  };

  const uploadAadharCombined = async () => {
    if (!aadharFront || !aadharBack) {
      toast.error("Please Upload Aadhaar front & back first");
      return;
    }
    setOpen(true);
    try {
      const res = await axios.post(url + "/borrower/adddocument", {
        borrower_uniqueno: uniqueNumber,
        doc_name: "aadhar_front",
        doc_names: "aadhar_back",
        doc_type: aadharFrontType,
        doc_types: aadharBackType,
        fileName: aadharFrontBase64,
        fileNames: aadharBackBase64,
        token,
        email,
      });

      if (res.data.auth === true) {
        toast.success(res.data.message);
      } else {
        toast.error(res.data.message);
        setOpen(false);
        return;
      }
      const updateBorrower = await axios.post(
        url + "/borrower/borrowertoalldetails",
        {
          token,
          email,
          borrower_uniqueno: uniqueNumber,
        }
      );

      if (!updateBorrower?.data?.auth) {
        setOpen(false);
        return;
      }
      updateBorrowerData((prev) => ({
        ...prev,
        borrower: updateBorrower?.data?.message?.borrower,
      }));
    } catch (err) {
      toast.error(err.message || "Something went wrong");
    }
    setOpen(false);
  };

  const validateFileFormat = (docTypeDisplay, file) => {
    const allowedFormats = DOC_ALLOWED_FORMATS[docTypeDisplay];
    const ext = file.name.split(".").pop().toLowerCase();

    if (!allowedFormats.includes(ext)) {
      toast.error(`Please upload ${docTypeDisplay} in ${allowedFormats.join(" or ").toUpperCase()} format only`);
      return false;
    }
    return true;
  };

  const handleFileChange = async (docTypeDisplay, files) => {
    const file = files[0];
    if (!file) return;

    if (!validateFileFormat(docTypeDisplay, file)) {
      return;
    }

    if (docTypeDisplay === "PAN Card") {
      await uploadPanWithOCR(file);
      updateUploadItem(docTypeDisplay, file);
      return;
    }

    if (docTypeDisplay === "Aadhar") {
      toast.error("Select Aadhaar Front or Back inputs below");
      return;
    }

    const apiName = DOC_NAME_TO_API[docTypeDisplay];
    await uploadKycDocument(apiName, file);
    updateUploadItem(docTypeDisplay, file);
  };

  const updateUploadItem = (docTypeDisplay, file) => {
    setUploadItems((prev) =>
      prev.map((item) =>
        item.type === docTypeDisplay ? { ...item, success: true, files: [file] } : item
      )
    );
  };

  const kycDocs = [
    {
      name: "Self Photo",
      exist: docExist.selfie,
      apiName: "borrower_selfphoto",
      isRequired: true,
      modalType: "single",
    },
    {
      name: "PAN Card",
      exist: docExist.pan,
      apiName: "borrower_pancard",
      isRequired: true,
      modalType: "single",
    },
    {
      name: "Aadhar Card Front",
      exist: docExist.aadharFront,
      apiName: "borrower_aadhar_front",
      isRequired: true,
      modalType: "single",
    },
    {
      name: "Aadhar Card Back",
      exist: docExist.aadharBack,
      apiName: "borrower_aadhar_back",
      isRequired: true,
      modalType: "single",
    },
    {
      name: "Current Address Proof",
      exist: docExist.currentAddressProof,
      apiName: "borrower_current_address_proof",
      isRequired: true,
      modalType: "single",
    },
    {
      name: "Election Card",
      exist: docExist.voterID,
      apiName: "borrower_election_card",
      isRequired: false,
      modalType: "multi",
    },
    {
      name: "Driving License",
      exist: docExist.drivingLicense,
      apiName: "borrower_driving_license",
      isRequired: false,
      modalType: "single",
    },
    {
      name: "Ration Card",
      exist: docExist.rationCard,
      apiName: "borrower_ration_card",
      isRequired: false,
      modalType: "single",
    },
    {
      name: "Passport",
      exist: docExist.passport,
      apiName: "borrower_passport",
      isRequired: false,
      modalType: "single",
    },
    {
      name: "Self Attested KYC",
      exist: docExist.selfAttested,
      apiName: "borrower_self_attested_kyc",
      isRequired: false,
      modalType: "multi",
    },
    {
      name: "Vehicle RC",
      exist: docExist.rc,
      apiName: "borrower_rc",
      isRequired: false,
      modalType: "single",
    }
  ];

  const viewBorrowerDocModal = (docName, title, modalType) => {
    setDocName(docName);
    setTitle(title);
    setModalType(modalType);
    setBorrowerDocModal(true);
  };

  const closeBorrowerDocModal = () => {
    setDocName("");
    setTitle("");
    setModalType("");
    setBorrowerDocModal(false);
  };

  const openLoader = useCallback(() => {
    setOpen(true);
  }, []);

  const closeLoader = useCallback(() => {
    setOpen(false);
  }, []);

  const removeSelectedFile = (type) => {
    setUploadItems((prev) =>
      prev.map((item) =>
        item.type === type ? { ...item, files: [], success: false } : item
      )
    );
  };

  return (
    <div className="min-h-screen bg-[#EDF5FF] flex">
      <Sidebar click={openView} />

      <div className={`flex-1 transition-all duration-300 ${isOpen ? "ml-[15%]" : "ml-0"}`}>
        <Backdrop sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }} open={open}>
          <CircularProgress color="inherit" />
        </Backdrop>

        <div className="w-full p-6 mt-20">

          {/* BACK BUTTON */}
          <div className="w-full max-w-[90rem] mt-2 flex items-center gap-2">
            <ChevronLeftIcon className="w-5 h-5 text-blue-600" />
            <button
              onClick={() => navigate(`/single/borrower/details/${id}`)}
              className="text-blue-600 text-sm no-underline hover:no-underline"
            >
              Back to Borrower Details
            </button>
          </div>

          {/* <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-8xl mx-auto"> */}
          <div className="grid grid-cols-1 md:grid-cols-[50%_50%] gap-6 max-w-20xl mx-auto">

            {(AddDocVisible || visible) && (
              <div className="bg-white mt-6 rounded-xl p-6 shadow border max-h-[calc(100vh-120px)] overflow-y-scroll">
                <h2 className="text-xl font-semibold mb-3">Upload KYC Documents</h2>
                <h3 className="text-lg font-bold mb-3">Add Document Types</h3>

                <div className="flex gap-3 mb-6">
                  <select
                    className="border border-gray-300 p-2 rounded-lg w-2/3 text-sm focus:ring-2 focus:ring-blue-500"
                    value={selectedType}
                    onChange={(e) => setSelectedType(e.target.value)}
                  >
                    <option value="">Select document type to add</option>
                    {ALL_DOC_TYPES.map((doc) => (
                      <option key={doc} value={doc}>
                        {doc}
                      </option>
                    ))}
                  </select>

                  <button className="bg-blue-600 text-white px-5 py-2 rounded-lg text-sm hover:bg-blue-700" onClick={handleAddDocType}>
                    Add Document
                  </button>
                </div>

                {/* new logic */}
                <div className="space-y-2">
                  {uploadItems.map((item, idx) => (
                    <div key={idx} className="border rounded-lg bg-gray-50 shadow-sm">

                      {/* DOC HEADER (Clickable) */}
                      <div
                        className="flex justify-between items-center p-3 bg-gray-100 cursor-pointer hover:bg-gray-200 rounded-t-lg transition"
                        onClick={() => setActiveDoc(activeDoc === item.type ? null : item.type)}
                      >

                        {/* LEFT SIDE — NAME + RED/GREEN ICON */}
                        <div className="flex items-center gap-2">
                          <span className="font-medium">{item.type}</span>

                          {/* STATUS ICON */}
                          {item.success ? (
                            <span className="text-green-600 text-lg font-bold">✔</span>
                          ) : (
                            <button
                              className="text-red-600 text-lg hover:text-red-800"
                              onClick={() => setUploadItems((prev) => prev.filter((d) => d.type !== item.type))}
                            >
                              ✕
                            </button>
                          )}
                        </div>

                        {/* RIGHT SIDE — ALWAYS SHOW ARROW */}
                        <div className="text-gray-600 text-xl">
                          {activeDoc === item.type ? <ExpandLess /> : <ExpandMore />}
                        </div>
                      </div>

                      {/* COLLAPSIBLE BODY */}
                      {activeDoc === item.type && (
                        <div className="p-4 border-t bg-white">

                          {/* AADHAR SPECIAL SECTION */}

                          {item.type === "Aadhar" ? (
                            <div className="space-y-3">
                              <label className="font-medium block">Upload Aadhaar</label>

                              <div className="flex items-center gap-4">
                                {/* Aadhaar Front */}
                                <label className="bg-white text-gray-800 px-4 py-2 rounded-lg border cursor-pointer shadow-sm">
                                  Upload Aadhaar Front
                                  <input
                                    type="file"
                                    className="hidden"
                                    onChange={(e) => uploadAadharFront(e.target.files[0])}
                                  />
                                </label>

                                {/* Aadhaar Back */}
                                <label className="bg-white text-gray-800 px-4 py-2 rounded-lg border cursor-pointer shadow-sm">
                                  Upload Aadhaar Back
                                  <input
                                    type="file"
                                    className="hidden"
                                    onChange={(e) => uploadAadharBack(e.target.files[0])}
                                  />
                                </label>

                                {/* Upload Button */}
                                <button
                                  className="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 transition"
                                  onClick={uploadAadharCombined}
                                >
                                  Upload Aadhaar Front and Back
                                </button>
                              </div>
                            </div>
                          ) : (
                            /* NORMAL DOC UPLOAD SECTION */
                            <div className="space-y-4">

                              <div className="flex items-center gap-4">
                                <label className="font-medium">Upload {item.type}</label>

                                <label className="bg-white text-gray-800 px-4 py-2 rounded-lg border cursor-pointer shadow-sm">
                                  Choose File(s)
                                  <input
                                    type="file"
                                    className="hidden"
                                    onChange={(e) => handleFileChange(item.type, e.target.files)}
                                  />
                                </label>

                                <span className="text-gray-600">
                                  {item.files?.length ? item.files[0].name : "No file chosen"}
                                </span>

                                {item.files?.length > 0 && !item.success && (
                                  <button
                                    className="text-red-500"
                                    onClick={() => removeSelectedFile(item.type)}
                                  >
                                    ✕
                                  </button>
                                )}
                              </div>
                            </div>
                          )}
                        </div>
                      )}
                    </div>
                  ))}
                </div>

              </div>
            )}

            {(ViewDocVisible || DownloadDocVisible || visible) && (
              <div className="bg-white mt-6 rounded-xl p-6 shadow border max-h-[calc(100vh-120px)] overflow-y-scroll">
                {borrowerDocModal && (
                  <ViewBorrowerDoc
                    borrowerDetails={borrowerDetails?.[0] || borrowerDetails}
                    docName={docName}
                    title={title}
                    closeModal={closeBorrowerDocModal}
                    openLoader={openLoader}
                    closeLoader={closeLoader}
                    modalType={modalType}
                  />
                )}

                <h2 className="text-xl font-semibold mb-3">View KYC Documents</h2>

                <div className="space-y-4">
                  {kycDocs
                    .filter((doc) => doc.exist === true)
                    .map((doc) => (
                      <div key={doc.apiName} className="flex justify-between items-center border-b pb-3">
                        <p className="font-medium text-gray-700">{doc.name}</p>

                        <button
                          onClick={() => viewBorrowerDocModal(doc.apiName, doc.name, doc.modalType)}
                          className="bg-blue-100 text-blue-700 px-4 py-1 rounded hover:bg-blue-200"
                        >
                          View
                        </button>
                      </div>
                    ))}
                </div>
              </div>
            )}

          </div>
        </div>
      </div>

      <ToastContainer />
    </div>
  );
}
